import React from "react";

export function SVGTikTok() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 1419 1628"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ticktok</title>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <path
          d="M599.678055,1414.83858 C708.33287,1413.08133 799.09868,1337.80281 824.387279,1236.60902 L825.262018,1232.98402 C800.972412,1337.212 707.4524,1414.87 595.79,1414.87 L595.79,1414.87 Z M1325.39677,416.388921 L1326.44832,416.91568 C1355.2672,431.2568 1386.112,442.14 1418.44,449.02 L1417.28326,448.771143 C1385.23634,441.825767 1354.38588,430.904687 1325.39677,416.388921 Z M409.26981,1322.46627 C440.894226,1338.22336 476.52,1347.07 514.24,1347.07 C644.1,1347.07 749.39,1242.07 749.84,1112.4 L749.84,1112.4 L749.84,0 L1030.12,0 L1030.12,35.82 C1031.10747,46.5336749 1032.53199,57.2025616 1034.39,67.8 L1034.389,67.799 C1053.6455,177.591 1118.86769,271.553385 1209.51534,329.145925 L1212.27,330.88 C1213.5752,332.30456 1214.89085,333.719409 1216.21682,335.124425 C1214.89146,333.717186 1213.57579,332.298883 1212.27,330.87 C1274.10836,369.449197 1345.5543,389.849944 1418.44,389.74 L1418.44,389.74 L1418.439,449.019 L1418.44,449.02 L1418.44,668.25 C1273.65,668.25 1139.59,622.24 1030.12,544.05 L1030.12,544.05 L1030.12,1112.41 C1030.12,1396.72 799.52,1627.2 515.07,1627.2 C408.94,1627.2 310.29,1595.13 228.34,1540.13 C228.325046,1540.11472 228.310093,1540.09944 228.29514,1540.08416 C90.6057925,1447.67804 1.13686838e-13,1290.61619 1.13686838e-13,1112.4 C1.13686838e-13,828.11 230.6,597.629929 515.08,597.629929 C538.718188,597.617621 562.329681,599.218004 585.75,602.42 L585.75,602.42 L585.75,665.53 L585.75,665.53 L585.74,665.53 L585.74,887.15 C563.2,880 539.17,876.12 514.24,876.12 C384.11,876.12 278.64,981.55 278.64,1111.6 C278.64,1203.55 331.36,1283.17 408.24,1321.95 L408.24,1321.95 Z"
          id="ticktok"
          fill="#000000"
          fill-rule="nonzero"
        ></path>
      </g>
    </svg>
  );
}
export function SVGYouTube() {
  return (
    <svg width="30" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.378 5.36c-.18-1.7-.564-3.58-1.983-4.567-1.098-.766-2.542-.795-3.89-.793l-8.548.006-8.221.008C5.59.016 4.478-.072 3.416.415c-.914.419-1.628 1.214-2.058 2.1C.76 3.746.637 5.14.565 6.503a63.546 63.546 0 0 0 .04 7.444c.116 1.809.412 3.808 1.833 4.96 1.26 1.021 3.038 1.071 4.672 1.073 5.186.005 10.374.01 15.563.012.665.002 1.359-.01 2.036-.083 1.334-.141 2.605-.517 3.462-1.49.865-.979 1.087-2.342 1.218-3.633.32-3.133.317-6.296-.011-9.427Zm-17.42 9.028V5.605l7.731 4.39-7.731 4.393Z"
        fill="#FF0209"
      />
    </svg>
  );
}

export function SVGInstagram() {
  return (
    <svg width="29" height="27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.67 0H7.55C3.647 0 .474 3.122.474 6.959v12.706c0 3.837 3.173 6.959 7.074 6.959h14.12c3.902 0 7.075-3.122 7.075-6.959V6.96C28.744 3.122 25.571 0 21.67 0ZM2.97 6.959c0-2.483 2.055-4.504 4.58-4.504h14.12c2.524 0 4.578 2.02 4.578 4.504v12.706c0 2.483-2.054 4.504-4.578 4.504H7.55c-2.525 0-4.58-2.02-4.58-4.504V6.96Z"
        fill="url(#a)"
      />
      <path
        d="M14.61 19.783c3.627 0 6.58-2.903 6.58-6.473s-2.951-6.472-6.58-6.472c-3.63 0-6.581 2.903-6.581 6.472 0 3.57 2.951 6.473 6.58 6.473Zm0-10.489c2.252 0 4.084 1.802 4.084 4.018 0 2.216-1.832 4.018-4.085 4.018-2.252 0-4.085-1.802-4.085-4.018 0-2.216 1.833-4.018 4.085-4.018Z"
        fill="url(#b)"
      />
      <path
        d="M21.8 7.883c.976 0 1.772-.781 1.772-1.744 0-.962-.794-1.744-1.773-1.744-.978 0-1.773.782-1.773 1.744 0 .963.795 1.744 1.773 1.744Z"
        fill="url(#c)"
      />
      <defs>
        <linearGradient
          id="a"
          x1="2.849"
          y1="24.878"
          x2="25.98"
          y2="1.364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAAD4F" />
          <stop offset=".35" stop-color="#DD2A7B" />
          <stop offset=".62" stop-color="#9537B0" />
          <stop offset="1" stop-color="#515BD4" />
        </linearGradient>
        <linearGradient
          id="b"
          x1="9.959"
          y1="17.887"
          x2="19.105"
          y2="8.586"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAAD4F" />
          <stop offset=".35" stop-color="#DD2A7B" />
          <stop offset=".62" stop-color="#9537B0" />
          <stop offset="1" stop-color="#515BD4" />
        </linearGradient>
        <linearGradient
          id="c"
          x1="20.546"
          y1="7.372"
          x2="23.011"
          y2="4.866"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FAAD4F" />
          <stop offset=".35" stop-color="#DD2A7B" />
          <stop offset=".62" stop-color="#9537B0" />
          <stop offset="1" stop-color="#515BD4" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function SVGFacebook() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width="30px"
      height="30px"
    >
      <path
        fill="#2165fe"
        d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848 c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588 l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z"
      />
    </svg>
  );
}

export function SVGWhatsApp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 16 16"
    >
      <path
        fill="#25d366"
        d="M13.69 2.335C12.206.822 10.157 0 8.064 0 3.62 0 .044 3.59.087 7.957c0 1.384.393 2.724 1.047 3.935L0 16l4.229-1.081a7.835 7.835 0 0 0 3.793.951c4.403 0 7.978-3.589 7.978-7.956a7.815 7.815 0 0 0-2.31-5.579zM8.064 14.53c-1.177 0-2.354-.303-3.357-.908l-.261-.13-2.529.649.654-2.465-.174-.26C.48 8.346 1.395 4.281 4.534 2.378c3.139-1.902 7.194-.994 9.112 2.12 1.918 3.113 1.003 7.134-2.136 9.037-1.003.649-2.224.995-3.445.995zm3.837-4.8-.48-.216s-.697-.303-1.133-.52c-.044 0-.087-.043-.131-.043-.13 0-.218.044-.305.087 0 0-.044.043-.654.735a.24.24 0 0 1-.218.13h-.044a.332.332 0 0 1-.174-.087l-.218-.086c-.48-.216-.916-.476-1.264-.822-.088-.086-.218-.173-.306-.26-.305-.302-.61-.648-.828-1.037l-.043-.087c-.044-.043-.044-.086-.088-.173 0-.086 0-.173.044-.216 0 0 .174-.216.305-.346.087-.086.13-.216.218-.303.087-.13.13-.302.087-.432-.043-.216-.566-1.384-.697-1.643a.504.504 0 0 0-.305-.216h-.48c-.087 0-.174.043-.262.043l-.043.043c-.087.043-.175.13-.262.173-.087.087-.13.173-.218.26-.305.389-.48.864-.48 1.34 0 .346.088.692.219.995l.043.13a7.207 7.207 0 0 0 1.613 2.205l.175.173c.13.13.261.216.349.346a7.812 7.812 0 0 0 3.138 1.643c.131.043.306.043.436.086h.436c.218 0 .48-.086.654-.173.131-.086.218-.086.306-.173l.087-.086c.087-.086.174-.13.261-.216.088-.087.175-.173.218-.26.088-.173.131-.389.175-.605v-.303s-.044-.043-.131-.086z"
      />
    </svg>
  );
}
